import { FC } from 'react';
import { Entity } from '../common/queryClient';
import { useShowLockData } from './useLocks';
import { ObjectType } from './types';
import { LockData } from './LockData';
import { ObjectLockId } from './query/useLockQuery';

export interface LockedByProps {
  id?: number;
  objectType: ObjectType;
  entity?: Pick<Entity, 'modifiedAt' | 'modifiedBy'> & { id?: number | null };
  discriminator?: string;
  additionalLocks?: ObjectLockId[];
}

export const LockedBy: FC<LockedByProps> = ({
  additionalLocks,
  entity,
  id,
  objectType,
  discriminator,
}) => {
  const { error, lockData } = useShowLockData(
    objectType,
    id ?? entity?.id ?? undefined,
    discriminator,
    additionalLocks,
  );

  return <LockData entity={entity} error={error} lockData={lockData} />;
};
